import { WfProcessStateVm } from './../../models/request';
import { Component, OnInit } from '@angular/core';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'app-my-requests-details',
  templateUrl: './my-requests-details.component.html',
  styleUrls: ['./my-requests-details.component.scss'],
})
export class MyRequestsDetailsComponent implements OnInit {
  items: WfProcessStateVm[];

  ngOnInit() {}
}
